export default __webpack_public_path__ + "static/media/Icon=Permissions.2a40feb8.svg";